module.exports = __webpack_public_path__ + "img/data-item3-3.128f600.png";